/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { useAppSelector } from '@/hooks';
import { useTranslations } from '@/hooks/useTranslations';
import { useGetTasksQuery } from '@/store/apis';
import { FlexBox, Title, Text, BusyIndicator } from '@ui5/webcomponents-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export default function IntroductionPhase() {
    const [videoIsLoading, setVideoIsLoading] = useState(true);
    const { t } = useTranslations();
    const { currentRunId: runId, currentProduct } = useAppSelector(state => state.productList);
    const { flowId, stepId } = useParams();
    const { data: taskQuery } = useGetTasksQuery({ flowId: flowId!, stepId: stepId!, runId: runId! }, { skip: !runId || !flowId || !stepId });
    const { translationTitleKey, description, videoHelpLink, title } = taskQuery?.tasks?.[0] || {};

    return (
        <FlexBox justifyContent="Center" style={{ padding: '5rem 1rem 1rem 1rem' }}>
            <FlexBox direction="Column" gap={32} alignItems="Center" style={{ maxWidth: 682, width: '100%' }}>
                <BusyIndicator active={!videoHelpLink || videoIsLoading} style={{ maxWidth: 560, width: '100%', height: 315 }} delay={0}>
                    <iframe
                        title="Help Video"
                        src={videoHelpLink || ''}
                        allowFullScreen
                        onLoad={() => setVideoIsLoading(false)}
                        sandbox="allow-scripts allow-same-origin allow-presentation"
                        style={{ width: '100%', aspectRatio: '16 / 9' }}
                    />
                </BusyIndicator>
                <FlexBox direction="Column" gap={16} alignItems="Center" style={{ maxWidth: 650 }}>
                    {translationTitleKey && (
                        <Title size="H2" style={{ textAlign: 'center' }}>
                            {t({ key: translationTitleKey, defaultText: title ?? '' })}
                        </Title>
                    )}
                    {description && <Text style={{ textAlign: 'center', fontSize: 16 }}> {t(description, currentProduct.productName)} </Text>}
                </FlexBox>
            </FlexBox>
        </FlexBox>
    );
}
